export function triggerOnSelectedRowsChanged(allowSelection, onSelectedRowsChanged, data, selectedRowIds, getRowId) {
    if (allowSelection && onSelectedRowsChanged) {
        onSelectedRowsChanged(getSelectedDataRows(data, selectedRowIds, getRowId));
    }
}
export function getSelectedDataRows(data, selectedRowIds, getRowId) {
    return data.filter((row) => selectedRowIds[getRowId(row)]);
}
